import palette from "../palette";

export default {
    indicator: {
        height: 2,
        background: `${palette.background.primary} !important`,
        width: 0
    },
}